import React , {useEffect} from "react";
import Carousal from "../components/Website/Carousal";
import HomeAbout from "../components/Website/HomeAbout";
import HomeService from "../components/Website/HomeService";
import Values from "../components/Website/Values";
import TestimonialCarousel from "../components/Website/TestimonialCarousal";
import Blog from "../components/Website/Blog";
// import { extractContentFromDom } from "../services/extractContent";
// import { saveHomeContentToDatabase } from "../services/saveHomeToDatabase";

const Home = () => {

  // useEffect(() => {
  //   // Extract content and save to the database on component mount
  //   const content = extractContentFromDom();
  //   saveHomeContentToDatabase(content)
  //     .then((response) => {
  //       if (response.ok) {
  //         console.log("Content saved successfully!");
  //       } else {
  //         console.error("Failed to save content:", response.statusText);
  //       }
  //     })
  //     .catch((error) => console.error("Error saving content:", error));
  // }, []);

  return (
    <div>
      <Carousal />
      <HomeAbout />
      <HomeService/>
      <Values/>
      <TestimonialCarousel/>
      <Blog/>
    </div>
  );
};

export default Home;
